import { Button } from './styles';

export default Button;
